import { render, staticRenderFns } from "./WaitingPageProgramElement.vue?vue&type=template&id=5173431b&"
import script from "./WaitingPageProgramElement.vue?vue&type=script&lang=js&"
export * from "./WaitingPageProgramElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports